<template>
  <div class="order_body_container">
    <div class="order_head">
      <h5>Commande n° {{order.ihrez}} - <strong>{{order.decoded_payment_status}}</strong></h5>
      <p>
        <em>
            Crée le {{order.created_at | moment-date }} |
            Mis à jour le {{order.updated_at | moment-date }}
        </em>
      </p>
    </div>
    <div class="tarif">
      <h5>Tarification</h5>
      <div class="validation_request_order_infos">
        <div class="order_infos_centered">
          <div class="order_value_container">
            <div class="order_value_container_row">
              <div class="order_value">
                <h5 class="text-white p-b-5">{{(order.total_ht / 100).toFixed(2)}} €</h5>
                <span class="fs-13">Sous-total H.T.</span>
              </div>
              <div class="order_value order_value_middle">
                <h5 class="text-white p-b-5">{{(order.tax_amount / 100).toFixed(2)}} €</h5>
                <span class="fs-13">T.V.A. ({{(order.tax_rate * 100).toFixed(2)}}%)</span>
              </div>
              <div class="order_value">
                <h5 class="text-white p-b-5">{{(order.total_ttc / 100).toFixed(2)}} €</h5>
                <span class="fs-13">Sous-total T.T.C</span>
              </div>
            </div>
            <hr style="color:white">
            <div class="order_value_container_row">
              <div class="order_value_2">
                <h5 class="text-white p-b-5">{{(order.deposit_amount / 100).toFixed(2)}} €</h5>
                <span class="fs-13">Dépot de garantie</span>
              </div>
              <div class="order_value" style="margin-left:auto;">
                <h5 class="text-white p-b-5">{{(order.total_to_pay / 100).toFixed(2)}} €</h5>
                <span class="fs-13">Total T.T.C</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:["order"],
  components:{
  },
}
</script>
<style scoped>

.order_body_container {}

.validation_request_order_infos {
  /*width: 350px;*/
  min-width: max-content;
  /*margin: 15px 0px 15px 15px;*/
  background-color: #eb7593;
  /*margin-top: 15px;
  margin-bottom: 15px;*/
  color: white;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  /*margin-left: 15px;*/
}
.order_value {
  display: inline-block;
  text-align: center;
  width:100px;
}

.order_value_middle {
  padding-left: 5px;
  padding-right: 5px;
}

.order_value_2 {
  display: inline-block;
  text-align: center;
  width:200px;
}

.order_value_container {

}

.order_head {
    border-bottom: solid 1px lightgrey;
}
.order_value_container_row {

}

.head {
  width: 100%;
}

.head h4 {
  display: inline-block;
}

.head button {
  display: inline-block;
}

.tarif {
  min-width: -webkit-max-content;
  padding: 0px 15px 0px 15px;
}

.tarif h4 {
  text-align: center;
}

@media screen and (max-width: 1200px) {
  .validation_request_order {
      border-right:0px;

  }


  .order_body_container {
     /*min-width: 350px;*/
     width:100%;
     padding: 0px 15px 0px 15px;
  }

  .tarif{
    padding: 0;
    margin: 0;
  }
  /*.validation_request_order_head {
    border-bottom: 0px;

  }*/
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/Contract/Order.vue